import React, {useRef} from "react";
import {LinkCopyPopup} from "../../../common/linkCopyPopup/LinkCopyPopup";
import {replaceDomain} from "../../../../utils/urlUtils";
import InputWithIcon from "../../../common/inputs/InputWithIcon";

export default function OfferItemLink({link, isLinksLoading, selectedDomain}) {

   const resultLink = (!isLinksLoading && link) ? replaceDomain(link, selectedDomain?.cname) : '';
    const childRef = useRef();

    return (
        <>
        <span className="link">
                                <label htmlFor="offer-link" className="input-label">Ссылка на оффер</label>
                                {<InputWithIcon value={resultLink} disabled
                                                            placeholder={isLinksLoading ? "Загрузка...." : "ссылка появится после нажатия на 'Получить ссылку'"}
                                                            iconClassName="ti ti-files"
                                                            onClickIcon={() => childRef.current.handleClickCopy(resultLink)}/>
                                }
                            </span>
            <LinkCopyPopup ref={childRef}/>
            </>
)
}